<template>

  <template v-if="timelines['daily'] && timelines['cat']">

    <div v-for="(types, category) in timelines" class="mb-4">
      <timeline :category="category" v-model="timelines[category]"></timeline>
    </div>
  </template>

  <template v-else>
    <timeline v-model="timelines"></timeline>
  </template>


  <div class="text-right mt-3">
    <button class="btn btn-xs btn-primary" type="button" @click="showCategorization">
      Manage Timelines
    </button>
  </div>

  <modal :id="modalId" title="Client Timelines">

    <timeline category="cat" v-model="catTimelines"></timeline>
    <hr>
    <timeline category="daily" v-model="dailyTimelines"></timeline>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">Cancel</button>
      <button type="button" class="btn btn-primary" @click="applyCategorization">Apply</button>
    </template>

  </modal>

</template>

<script>
import HasModal from "../mixins/HasModal";

export default {

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'manageTimelines'
    },

    // Initial timelines
    initialTimelines: {
      type: Object,
      required: true,
    },
  },

  mixins: [HasModal],

  data() {
    return {
      timelines: this.initialTimelines,
      dailyTimelines: [],
      catTimelines: [],
    }
  },

  methods: {
    /**
     * Split timelines into cat/daily and show modal dialog.
     */
    showCategorization() {
      this.catTimelines = JSON.parse(JSON.stringify(this.timelines['cat'] || this.timelines));
      this.dailyTimelines = JSON.parse(JSON.stringify(this.timelines['daily'] || this.timelines));

      this.$modal.show(this.modalId);
    },

    applyCategorization() {
      this.timelines = {
        cat: this.catTimelines,
        daily: this.dailyTimelines,
      };

      this.hideModal();
    },
  }

}
</script>
